module.exports = __webpack_public_path__ + "img/vertical_1_1_5012.379d147d.png";